import { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import StatisticsApp from '../pages/statistics/app';
import StatisticsAppDay from '../pages/statistics/app-day';
import StatisticsAppStudent from '../pages/statistics/app-student';
import StatisticsAttendance from '../pages/statistics/attendance';
import StatisticsDttt from '../pages/statistics/dttt';
import StatisticsELearning from '../pages/statistics/e-learning';
import StatisticsEvent from '../pages/statistics/event';
import StatisticsEventRefund from '../pages/statistics/event-refund';
import StatisticsHomework from '../pages/statistics/homework';
import StatisticsPlacementTest from '../pages/statistics/placement-test';
import StatisticsRefund from '../pages/statistics/refund';
import StatisticsRegularTest from '../pages/statistics/regular-test';
import StatisticsSales from '../pages/statistics/sales';
import StatisticsStudentEnroll from '../pages/statistics/student-enroll';
import StatisticsStudentEnrollMonth from '../pages/statistics/student-enroll-month';
import StatisticsStudentEnrollWeek from '../pages/statistics/student-enroll-week';
import StatisticsStudentRetire from '../pages/statistics/student-retire';
import StatisticsText from '../pages/statistics/text';
import StatisticsWeb from '../pages/statistics/web';
import StatisticsBook from '../pages/statistics/book';
import StatisticsArticles from '../pages/statistics/articles';
import StatisticsPBT from '../pages/statistics/pbt';
import StatisticsSalesNice from '../pages/statistics/sales-nice';
import StatisticsRefundNice from '../pages/statistics/refund-nice';
import StatisticsCac from '../pages/statistics/cac';
import StatisticsConsent from '../pages/statistics/consent';

const StatisticsRouter: FC = () => {
  return (
    <Switch>
      <Route path="/statistics/student-enroll" exact component={StatisticsStudentEnroll} />
      <Route path="/statistics/student-enroll-month" exact component={StatisticsStudentEnrollMonth} />
      <Route path="/statistics/student-enroll-week" exact component={StatisticsStudentEnrollWeek} />
      <Route path="/statistics/student-retire" exact component={StatisticsStudentRetire} />
      <Route path="/statistics/web" exact component={StatisticsWeb} />
      <Route path="/statistics/sales" exact component={StatisticsSales} />
      <Route path="/statistics/sales-nice" exact component={StatisticsSalesNice} />
      <Route path="/statistics/refund" exact component={StatisticsRefund} />
      <Route path="/statistics/refund-nice" exact component={StatisticsRefundNice} />
      <Route path="/statistics/text" exact component={StatisticsText} />
      <Route path="/statistics/regular-test" exact component={StatisticsRegularTest} />
      <Route path="/statistics/placement-test" exact component={StatisticsPlacementTest} />
      <Route path="/statistics/e-learning" exact component={StatisticsELearning} />
      <Route path="/statistics/dttt" exact component={StatisticsDttt} />
      <Route path="/statistics/homework" exact component={StatisticsHomework} />
      <Route path="/statistics/book" exact component={StatisticsBook} />
      <Route path="/statistics/articles" exact component={StatisticsArticles} />
      <Route path="/statistics/attendance" exact component={StatisticsAttendance} />
      <Route path="/statistics/app" exact component={StatisticsApp} />
      <Route path="/statistics/app-day" exact component={StatisticsAppDay} />
      <Route path="/statistics/app-student" exact component={StatisticsAppStudent} />
      <Route path="/statistics/event" exact component={StatisticsEvent} />
      <Route path="/statistics/event-refund" exact component={StatisticsEventRefund} />
      <Route path="/statistics/pbt" exact component={StatisticsPBT} />
      <Route path="/statistics/cac" exact component={StatisticsCac} />
      <Route path="/statistics/consent" exact component={StatisticsConsent} />
    </Switch>
  );
};

export default StatisticsRouter;